<template>
  <b-button :size='size' :variant="variant" v-if="path"
  :href="`${this.$config.files.staticServerUrl}/${this.path}`"
  :target="target">
    <font-awesome-icon :icon="icon" class="mx-1"/>
    {{ label }}
  </b-button>
</template>

<script>
export default {
  name: 'file-link',
  props: {
    target: { type: String, default:'_blank' },
    size: { type: String, default: 'lg' },
    path: { type: String },
    icon: { type: String, default: 'file' },
    label: { type: String },
    variant: { type: String, default: 'link' }
  }
}
</script>
